import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  staticFilesUrl:string;
  pagesPrefix:string;
  billingKey: string;
  billingEnv: string;
  redirectUrl: string;
  urlCathoHome: string;
  urlWhatsApp: string;
  urlCathoCV: string;
  paymentUrl: string;
  billingChallengeKey: string;
  billingSiteKey: string;
  redirectUrlLP?: string;
  environment: string;
  redirectUrlSA: string;
  urlJobList: string;
  urlHelpCenter: string;
  compatibilityExpID: string;
  enableAdyen?: boolean;
  lastDateMktPromo?: string;
  urlCareerAndSuccess?: string;
  checkoutDisabled?: boolean;
  checkoutAllowedUserIds?: string[];
}

const initialState: State =
{
  staticFilesUrl: process.env.ASSETS_SERVER_URL,
  pagesPrefix: process.env.PAGES_PREFIX,
  billingKey: process.env.BILLING_API_KEY,
  billingEnv: process.env.BILLING_API_ENV,
  redirectUrl: process.env.URL_CATHO_WELCOME,
  urlCathoHome: process.env.URL_CATHO_HOME,
  urlWhatsApp: process.env.URL_WHATSAPP,
  urlCathoCV: process.env.URL_CATHO_CV,
  paymentUrl: process.env.PAYMENT_URL,
  billingChallengeKey: process.env.BILLING_CHALLENGE_API_KEY,
  billingSiteKey: process.env.BILLING_SITE_KEY,
  redirectUrlLP: null,
  environment: process.env.APPLICATION_ENV,
  redirectUrlSA: process.env.URL_CATHO_JOB_LIST,
  urlJobList: process.env.URL_CATHO_JOB_LIST,
  urlHelpCenter: process.env.HELP_CENTER_URL,
  compatibilityExpID: process.env.COMPATIBILITY_EXPERIMENT_ID || null,
  enableAdyen: process.env.ENABLE_ADYEN === '1',
  lastDateMktPromo: process.env.LAST_DATE_MKT_PROMO || null,
  urlCareerAndSuccess: process.env.URL_CAREER_AND_SUCCESS,
  checkoutDisabled: process.env.CHECKOUT_DISABLED === '1',
  checkoutAllowedUserIds: (process.env.CHECKOUT_ALLOWED_USER_IDS || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
}

const server = createSlice({
  name: 'server',

  initialState,

  reducers: {
    setRedirectUrl(state, action: PayloadAction<any>) {
      state.redirectUrl = action.payload.redirectUrl;
      state.redirectUrlLP = action.payload.redirectUrlLP;
    },
    setRedirectUrlSA(state, action: PayloadAction<any>) {
      state.redirectUrlSA = action.payload.redirectUrlSA;
    },
  },
});

export const {
  setRedirectUrl,
  setRedirectUrlSA,
} = server.actions;

export default server.reducer;
